<template>
  <div class="set-tiem-left">
    <div class="set-time-header">{{title ? title : OneRow.title}}</div>
    <div class="set-time-content">
      <div class="flex-row-between">
        <span class="limit-wechat" v-if="!isPeriod">{{$t('Set Limits')}}</span>
        <span class="limit-wechat" v-else>{{$t('Set Downtime')}}</span>
        <el-switch v-if="!isPeriod"
          v-model="limitValue"
          active-color="#2bcf88"
          @change="limitValueChange(limitValue)"
          inactive-color="#888">
        </el-switch>
        <el-switch v-else
          v-model="limitValueTwo"
          active-color="#2bcf88"
          @change="limitValueTwoChange(limitValueTwo)"
          inactive-color="#888">
        </el-switch>
      </div>
      <div class="time-select">
        <div v-if="!isPeriod">
          <!-- <smooth-picker ref="smoothPicker" :data="pickerDatas" :change="change"/> -->
          <div class="flex-row-center set-left-picker">
            <div style="width:100%" class="flex-row-start">
              <el-select style="width:50%" :disabled="disabledMin" v-model="valueHour" size="mini" @change="hourTimeValueTwo" placeholder='请选择'>
                <el-option
                  v-for="(date, i) in hourValue" :key="i" :label="date" :value="date">
                </el-option>
              </el-select>
              <div style="color:#10cd6c">hour</div>
            </div>
            <div style="width:100%" class="flex-row-start">
              <el-select style="width:50%" :disabled="disabledMin" v-model="valueMin" size="mini" @change="minTimeValueTwo" placeholder='请选择'>
                <el-option
                  v-for="(date, m) in minValue" :key="m" :label="date" :value="date">
                </el-option>
              </el-select>
              <div style="color:#10cd6c">min</div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="flex-row-between set-right-picker">
            <span>{{$t('Start')}}</span>
            <div>
              <el-time-picker
              :disabled="disabledtime"
              size="mini"
                v-model="startValue"
                value-format="HH:mm:ss"
                format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:00'
                }"
                placeholder="任意时间点">
              </el-time-picker>
            </div>
          </div>
          <div class="flex-row-between set-right-picker">
            <span>{{$t('End')}}</span>
            <div>
              <el-time-picker
              size="mini"
                v-model="endValue"
                :disabled="disabledtime"
                value-format="HH:mm:ss"
                format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:00'
                }"
                placeholder="任意时间点">
              </el-time-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="set-time-note">
        {{$t('Your kid cannot use the device during the time limit.')}}
      </div>
      <div class="flex-row-between" style="margin-top:20px;">
        <span class="set-time-Repeat">{{$t('Repeat')}}</span>
        <el-switch
          v-if="!isPeriod"
          v-model="repeatValue"
          @change="limitrepeatValue(repeatValue)"
          active-color="#2bcf88"
          inactive-color="#888">
        </el-switch>
        <el-switch
          v-else
          v-model="repeatValueTwo"
          @change="limitrepeatTwoValue(repeatValueTwo)"
          active-color="#2bcf88"
          inactive-color="#888">
        </el-switch>
      </div>
      <div v-if="!isPeriod" class="flex-row-start" style="margin-top:30px;flex-wrap:wrap;">
        <el-button v-for="(item, i) in weekSelected" :key="i" @click="onWeek(item, 'left')" :disabled="openDisabled" :class="item.isSelected ? 'select-week' : 'normal-week'">{{item.label}}</el-button>
      </div>
      <div v-else class="flex-row-start" style="margin-top:30px;flex-wrap:wrap;">
        <el-button v-for="(item, i) in weekSelectedTwo" :key="i" @click="onWeek(item, 'right')" :disabled="openDisabledTwo" :class="item.isSelected ? 'select-week' : 'normal-week'">{{item.label}}</el-button>
      </div>
      <div v-if="setException" @click="onSetApp" class="flex-row-between set-exception">
        <div>
          <div class="set-exception-app">{{$t('Always Allowed')}}</div>
          <div class="set-exception-time">{{$t('Choose apps that your kids can use all the time.')}}</div>
        </div>
        <div :class="openDisabled || openDisabledTwo ? 'set-exce-icon' : 'set-exce-icon-hover'"></div>
      </div>
      <div :class="setException ? 'set-time-footer' : 'set-time-footer-two'">
        <div style="margin-top:30px;" class="setbtn_footer">
          <el-button class="normalBtn" @click="onSave" style="width:120px;height:50px;font-size:20px;">{{$t('Save')}}</el-button>
          <el-button class="otherBtn" @click="onCancel" style="width:120px;height:50px;font-size:20px;margin-left:15px;border-radius:50px;">{{$t('Cancel')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'set-usage-time',
  props: ['title', 'isPeriod', 'setException', 'OneRow'],
  data () {
    return {
      isSelectedWeek: ['MON'],
      isSelectedWeekTwo: ['MON'],
      valueHour: 2,
      valueMin: 30,
      disabledMin: false,
      limitValue: true,
      limitValueTwo: true,
      repeatValue: true,
      repeatValueTwo: true,
      openDisabled: false,
      openDisabledTwo: false,
      disabledtime: false,
      weekSelected: [
        { label: this.$t('Monday'), isSelected: true, name: 'MON' },
        { label: this.$t('Tuesday'), isSelected: false, name: 'TUE' },
        { label: this.$t('Wednesday'), isSelected: false, name: 'WED' },
        { label: this.$t('Thursday'), isSelected: false, name: 'THU' },
        { label: this.$t('Friday'), isSelected: false, name: 'FRI' },
        { label: this.$t('Saturday'), isSelected: false, name: 'SAT' },
        { label: this.$t('Sunday'), isSelected: false, name: 'SUN' }
      ],
      weekSelectedTwo: [
        { label: this.$t('Monday'), isSelected: true, name: 'MON' },
        { label: this.$t('Tuesday'), isSelected: false, name: 'TUE' },
        { label: this.$t('Wednesday'), isSelected: false, name: 'WED' },
        { label: this.$t('Thursday'), isSelected: false, name: 'THU' },
        { label: this.$t('Friday'), isSelected: false, name: 'FRI' },
        { label: this.$t('Saturday'), isSelected: false, name: 'SAT' },
        { label: this.$t('Sunday'), isSelected: false, name: 'SUN' }
      ],
      setUserTime: 0,
      startValue: '08:00:00',
      endValue: '18:00:00',
      startValueTwo: '08:10:00',
      hourValue: [],
      minValue: []
    }
  },
  methods: {
    onSetApp () {
      if ((this.limitValue === false && this.repeatValue === false) || (this.limitValueTwo === false && this.repeatValueTwo === false)) {
        this.$emit('onSetApp', false)
      } else {
        this.$emit('onSetApp', true)
      }
    },
    hourTimeValueTwo (e) {
      this.valueHour = e
    },
    minTimeValueTwo (e) {
      this.valueMin = e
    },
    onWeek (item, type) {
      if (type === 'left') {
        this.setSelected(this.isSelectedWeek, item)
      } else if (type === 'right') {
        this.setSelected(this.isSelectedWeekTwo, item)
      }
      // if (this.isSelectedWeek.length <= 1) {
      //   if (this.isSelectedWeek.indexOf(item.name) === -1) {
      //     item.isSelected = !item.isSelected
      //     this.isSelectedWeek.push(item.name)
      //     console.log(this.isSelectedWeek)
      //   }
      // } else {
      //   console.log(item.name, this.isSelectedWeek.indexOf(item.name))
      //   if (this.isSelectedWeek.indexOf(item.name) === -1) {
      //     item.isSelected = !item.isSelected
      //     this.isSelectedWeek.push(item.name)
      //     console.log(this.isSelectedWeek)
      //   } else {
      //     item.isSelected = !item.isSelected
      //     let index = this.isSelectedWeek.indexOf(item.name)
      //     this.isSelectedWeek.splice(index, 1)
      //     console.log(this.isSelectedWeek)
      //   }
      // }
    },
    // 星期几数据传入对应选取逻辑
    setSelected (week, item) {
      if (week.length <= 1) {
        if (week.indexOf(item.name) === -1) {
          item.isSelected = !item.isSelected
          week.push(item.name)
        }
      } else {
        if (week.indexOf(item.name) === -1) {
          item.isSelected = !item.isSelected
          week.push(item.name)
        } else {
          item.isSelected = !item.isSelected
          let index = week.indexOf(item.name)
          week.splice(index, 1)
        }
      }
    },
    // 保存$emit onSaveUseTime   onSaveUsePeriod
    onSave () {
      // 时长的周
      let selectWeek = this.weekSelected.filter(c => c.isSelected)
      let weeks = []
      for (let i = 0; i < selectWeek.length; i++) {
        weeks.push(selectWeek[i].name)
      }
      let selectWeekTwo = this.weekSelectedTwo.filter(c => c.isSelected)
      let weeksTwo = []
      for (let i = 0; i < selectWeekTwo.length; i++) {
        weeksTwo.push(selectWeekTwo[i].name)
      }
      this.setUserTime = Number(this.valueHour) * 60 + Number(this.valueMin)
      if (!this.isPeriod) {
        let obj = {
          limitValue: this.limitValue,
          repeatValue: this.repeatValue,
          setUserTime: this.setUserTime,
          weeks
          // selectWeek
        }
        this.$emit('onSaveUseTime', obj)
      } else {
        let obj = {
          limitValueTwo: this.limitValueTwo,
          repeatValueTwo: this.repeatValueTwo,
          startValue: this.startValue,
          endValue: this.endValue,
          weeksTwo
        }
        this.$emit('onSaveUsePeriod', obj)
      }
    },
    dateFormatter: function (aDate) {
      let date = this.$Formatter.durationSavePeriod(aDate / 1000)
      return date
    },
    onCancel () {
      this.$emit('onCancel', true)
    },
    // 时长上面的开关
    limitValueChange (v) {
      if (v === false) {
        this.disabledMin = true
        this.repeatValue = false
        this.openDisabled = true
        this.weekSelected.map((c) => {
          c.isSelected = false
        })
      } else {
        this.disabledMin = false
        this.repeatValue = true
        this.openDisabled = false
        this.weekSelected.map((c, index) => {
          if (c.name === this.isSelectedWeek[index]) {
            c.isSelected = true
          }
        })
      }
    },
    // 时长下面的开关
    limitrepeatValue (v) {
      if (v === false) {
        this.disabledMin = true
        this.limitValue = false
        this.openDisabled = true
        this.weekSelected.map((c) => {
          c.isSelected = false
        })
      } else {
        this.disabledMin = false
        this.limitValue = true
        this.openDisabled = false
        this.weekSelected.map((c, index) => {
          if (c.name === this.isSelectedWeek[index]) {
            c.isSelected = true
          }
        })
      }
    },
    // 时段上的开关
    limitValueTwoChange (v) {
      if (v === false) {
        this.repeatValueTwo = false
        this.openDisabledTwo = true
        this.disabledtime = true
        this.weekSelectedTwo.map((c) => {
          c.isSelected = false
        })
      } else {
        this.repeatValueTwo = true
        this.openDisabledTwo = false
        this.disabledtime = false
        this.weekSelectedTwo.map((c, index) => {
          if (c.name === this.isSelectedWeekTwo[index]) {
            c.isSelected = true
          }
        })
      }
    },
    // 时段下的开关
    limitrepeatTwoValue (v) {
      if (v === false) {
        this.limitValueTwo = false
        this.openDisabledTwo = true
        this.disabledtime = true
        this.weekSelectedTwo.map((c) => {
          c.isSelected = false
        })
      } else {
        this.limitValueTwo = true
        this.openDisabledTwo = false
        this.disabledtime = false
        this.weekSelectedTwo.map((c, index) => {
          if (c.name === this.isSelectedWeekTwo[index]) {
            c.isSelected = true
          }
        })
      }
    }
  },
  mounted () {
    for (let i = 0; i <= 60; i++) {
      (i <= 23) && this.hourValue.push(i)
      this.minValue.push(i)
    }
  },
  created () {
    if (!this.isPeriod) {
      console.log(this.OneRow, '++++', this.OneRow.timeLengthTwo, this.OneRow.timeLengthOne)
      // 限制时长传进来判断是否限制过
      // console.log(this.OneRow.timeLengthTwo, Object.keys(this.OneRow.timeLengthTwo).length)
      if (this.OneRow.timeLengthTwo === undefined ? (this.OneRow.timeLengthTwo === undefined) : (Object.keys(this.OneRow.timeLengthTwo).length === 0)) {
        this.limitValueChange(false)
        this.limitrepeatValue(false)
      } else {
        let getimeLengthTwo = this.OneRow.timeLengthTwo
        if (typeof (getimeLengthTwo.days) === 'string') {
          let reg = /^\[|\]$/ig
          if (reg.test(getimeLengthTwo.days)) {
            getimeLengthTwo.days = getimeLengthTwo.days.replace(reg, '')
          }
          let getOneWeeks = getimeLengthTwo.days.split(',')
          console.log(getOneWeeks)
          this.isSelectedWeek = []
          this.isSelectedWeek = this.isSelectedWeek.concat(getOneWeeks)
          console.log(this.isSelectedWeek)
          for (let i = 0; i < this.weekSelected.length; i++) {
            this.weekSelected[i].isSelected = false
            for (let n = 0; n < this.isSelectedWeek.length; n++) {
              // console.log(this.isSelectedWeek[n].trim())
              let isSelectedWeeks = this.isSelectedWeek[n].trim()
              if (this.weekSelected[i].name === isSelectedWeeks) {
                this.weekSelected[i].isSelected = true
              }
            }
          }
        } else if (getimeLengthTwo.days.length !== 0) {
          this.isSelectedWeek = []
          this.isSelectedWeek = this.isSelectedWeek.concat(getimeLengthTwo.days)
          console.log(this.isSelectedWeek)
          for (let i = 0; i < this.weekSelected.length; i++) {
            this.weekSelected[i].isSelected = false
            for (let n = 0; n < this.isSelectedWeek.length; n++) {
              let isSelectedWeeks = this.isSelectedWeek[n].trim()
              if (this.weekSelected[i].name === isSelectedWeeks) {
                this.weekSelected[i].isSelected = true
              }
            }
          }
        }
        let setHour = parseInt(getimeLengthTwo.timeLen / 60)
        let setMin = parseInt(getimeLengthTwo.timeLen % 60)
        this.valueHour = setHour
        this.valueMin = setMin
      }
    } else {
      // 限制时间段
      // console.log(this.OneRow.timeLengthOne, Object.keys(this.OneRow.timeLengthOne).length)
      if (this.OneRow.timeLengthOne === undefined ? (this.OneRow.timeLengthOne === undefined) : (Object.keys(this.OneRow.timeLengthOne).length === 0)) {
        this.limitValueTwoChange(false)
        this.limitrepeatTwoValue(false)
      } else {
        // 获取对应的星期几
        let getimeLengthOne = this.OneRow.timeLengthOne
        // console.log(getimeLengthOne)
        if (typeof (getimeLengthOne.days) === 'string') {
          let reg = /^\[|\]$/ig
          if (reg.test(getimeLengthOne.days)) {
            getimeLengthOne.days = getimeLengthOne.days.replace(reg, '')
          }
          let getOneWeeks = getimeLengthOne.days.split(',')
          // console.log(getOneWeeks)
          this.isSelectedWeekTwo = []
          this.isSelectedWeekTwo = this.isSelectedWeekTwo.concat(getOneWeeks)
          // console.log(this.isSelectedWeekTwo)
          for (let i = 0; i < this.weekSelectedTwo.length; i++) {
            this.weekSelectedTwo[i].isSelected = false
            for (let n = 0; n < this.isSelectedWeekTwo.length; n++) {
              let isSelectedWeeks = this.isSelectedWeekTwo[n].trim()
              if (this.weekSelectedTwo[i].name === isSelectedWeeks) {
                this.weekSelectedTwo[i].isSelected = true
              }
            }
          }
        } else if (getimeLengthOne.days.length !== 0) {
          this.isSelectedWeekTwo = []
          this.isSelectedWeekTwo = this.isSelectedWeekTwo.concat(getimeLengthOne.days)
          // console.log(this.isSelectedWeekTwo)
          for (let i = 0; i < this.weekSelectedTwo.length; i++) {
            this.weekSelectedTwo[i].isSelected = false
            for (let n = 0; n < this.isSelectedWeekTwo.length; n++) {
              let isSelectedWeeks = this.isSelectedWeekTwo[n].trim()
              if (this.weekSelectedTwo[i].name === isSelectedWeeks) {
                this.weekSelectedTwo[i].isSelected = true
              }
            }
          }
        }
        // // 获取时间段
        this.startValue = getimeLengthOne.startTime
        this.endValue = getimeLengthOne.endTime
      }
    }
  }
}
</script>
<style lang="scss">
.set-left-picker {
  width:100%;
  padding-top: 30px;
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-input--mini .el-input__inner{
    width: 100%;
    height: 50px;
    border: none;
    text-align: right;
    font-size: 30px;
  }
}
  .set-tiem-left, .set-tiem-right{
    width:100%;
    .set-time-header{
      width:100%;
      height:69px;
      padding-left:25px;
      text-align:left;
      line-height: 69px;
      border-bottom:1px solid #e5e5e5;
      font-size: 18px;
      box-sizing: border-box;
      text-align: center;
    }
    .set-time-content{
      padding:3% 39px 0 30px;
      background-color: #fff;
      border-radius: 20px;
      .limit-wechat{
        font-family: 'Nunito-Regular';
        font-size: 18px;
        color: #333333;
      }
      .time-select{
        width:100%;
        height:120px;
      }
      .set-time-note{
        font-family: 'Nunito-Regular';
        font-size: 14px;
        color: #989898;
        text-align: left;
        padding-bottom:36px;
        box-sizing: border-box;
        border-bottom:1px solid #e5e5e5;
      }
      .set-time-Repeat{
        font-family: 'Nunito-Regular';
        font-size: 16px;
        color: #333333;
      }
      .select-week{
        width: 124px;
        height: 38px;
        // line-height:38px;
        color: #fff;
        background: linear-gradient(to right, #2de075, #0dca6d);
        background-color: #10cd6c;border-color:#10cd6c;
        // color:#2bcf88;
        border-radius: 19px;
        // border: solid 1px #2bcf88;
        margin:15px 15px 0 0;
        cursor: pointer;
      }
      .normal-week{
        width: 124px;
        height: 38px;
        // line-height:38px;
        color:#979797;
        border-radius: 19px;
        border: solid 1px #979797;
        margin:15px 15px 0 0;
        cursor: pointer;
      }
      .set-time-footer{
        width:100%;
        border-top:1px solid #e5e5e5;
      }
      .set-time-footer-two{
        width:100%;
        border-top:1px solid #e5e5e5;
        margin-top: 20%;
      }
      .row-group{
        font-family: 'Nunito-Regular';
        color: #333333;
      }
      .divider{
        font-family: 'Nunito-Regular';
        color: #119b5f;
      }
      .set-right-picker{
        padding-top:30px;
        .el-date-editor.el-input, .el-date-editor.el-input__inner{
          width:108px;
        }
        .el-input--mini .el-input__inner{
          width: 108px;
          border-radius: 16px;
        }
      }
      .set-exception{
        margin-top:30px;
        padding: 30px 0;
        box-sizing: border-box;
        cursor: pointer;
        border-top:1px solid #e5e5e5;
        .set-exce-icon{
          width:13px;
          height:24px;
          background:url('../../../static/images/mro.png') 0 0 no-repeat;
        }
        .set-exce-icon-hover{
          background:url('../../../static/images/mro.png') 0 0 no-repeat;
          width:13px;height:24px;
        }
        &:hover{
          .set-exce-icon-hover{
            background:url('../../../static/images/mro_hove.png') 0 0 no-repeat;
            width:13px;height:24px;
          }
        }
        .set-exception-app {
          font-size: 20px;
          color: #333333;
          text-align: left;
        }
        .set-exception-time{
          font-size: 16px;
          color: #989898;
          padding-top: 10px;
        }
      }
    }
  }
   .setbtn_footer{
      padding-bottom: 20px;
    }
@media (max-width: 475px){
  .set-time-content{
    padding:3% 15px 0 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/SetUsageTime.vue